import { type Writable, writable, get } from 'svelte/store';
import type { Location } from '../utils/location';
import SessionStorage from '../utils/session-storage';

const location: Writable<Location | null> = writable(null);

export const getCurrentLocation = (): Location | null => get(location);

export const setCurrentLocation = (value: Location | null): void => {
  location.set(value);
  if (location) SessionStorage.set('location', JSON.stringify(value));
  else SessionStorage.clear('location');
};

export const restoreLocation = (): void => {
  const storageLocation = SessionStorage.get('location');
  if (storageLocation) {
    location.set(JSON.parse(storageLocation));
  }
};

export default location;
